import {Options} from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

export const emotionCacheOptions: Record<'rtl' | 'ltr', Options> = {
  rtl: {
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
  ltr: {
    key: 'muiltr',
    stylisPlugins: [],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
};
